import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { KoreanMesotherapyHero } from '../components/korean-mesotherapy/KoreanMesotherapyHero';
export function KoreanMesotherapyPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2551">
      <Navigation data-id="element-2552" />
      <main data-id="element-2553">
        <KoreanMesotherapyHero data-id="element-2554" />
      </main>
      <Footer data-id="element-2555" />
    </div>;
}